import { Center, Stack, Text, ThemeIcon } from 'ui';
import { IconFees } from 'ui/Icons';

import { AddStudentButton } from '../../organisms/buttons/AddStudentButton';

const NoStudents = () => {
  return (
    <Center>
      <Stack gap={24}>
        <ThemeIcon size={180} radius="md" variant="transparent" m="auto">
          <IconFees size={180} />
        </ThemeIcon>
        <Stack gap={8}>
          <Text size="18px" fw="600" ta="center">
            Add Your Student(s)
          </Text>
          <Text size="14px" fw="400" ta="center">
            Connect your student&apos;s account to get started.
          </Text>
        </Stack>
        <AddStudentButton />
      </Stack>
    </Center>
  );
};

export { NoStudents };
